import { useState } from 'react'
import Accountprice from '../../../utils/Accountprice';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { IoIosCloseCircleOutline } from 'react-icons/io';

const Table = ({ ApiData, Count, fullData }) => {
  const nvg = useNavigate();
  const [showtrack, setshowtrack] = useState(false);
  const [awbNumber, setawbNumber] = useState(null);
  const [trackingData, setTrackingData] = useState({});

  const fetchTrackingData = async (item) => {
    setawbNumber(item);
    try {
      const url = `${process.env.REACT_APP_API_URL}ship/track-order-now?awb=${item}`;
      const response = await axios.get(url);

      if (response.data) {
        const jsonData = JSON.parse(response.data);
        setTrackingData(jsonData);
        setshowtrack(true);
      } else {
        setshowtrack(false);
      }
    } catch (error) {
      console.error('Error fetching tracking data:', error);
      setshowtrack(false);
    }
  };


    return (
        <>
        <table className="table">
            <thead>
                <tr>
                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "15%",
                            textAlign: "center",
                        }}
                    >
                        Image
                    </th>
                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "12%",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Product Name
                    </th>

                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "16%",
                            textWrap: 'nowrap',
                            textAlign: "center",
                        }}
                    >
                        Offer Price
                    </th>

                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "15%",
                            textAlign: "center",
                        }}
                    >
                        Quantity
                    </th>
                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "15%",
                            textWrap: "nowrap",
                            textAlign: "center",
                        }}
                    >
                        Discount
                    </th>
                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "18%",
                            textWrap: 'nowrap',
                            textAlign: "center",
                        }}
                    >
                        Total Amount
                    </th>

                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "18%",
                            textWrap: 'nowrap',
                            textAlign: "center",
                        }}
                    >
                        Taxable Value
                    </th>
                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "18%",
                            textWrap: 'nowrap',
                            textAlign: "center",
                        }}
                    >
                        GST Rate
                    </th>
                    <th
                        className="family"
                        style={{
                            fontWeight: 600,
                            fontSize: "13px",
                            width: "18%",
                            textWrap: 'nowrap',
                            textAlign: "center",
                        }}
                    >
                        GST Amount
                    </th>


                </tr>
            </thead>
            <tbody>
                {ApiData[0]?.product__title ? (
                    ApiData.map((item, index) => (<>
                        <tr>
                            <td
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <div
                                    onClick={() => {
                                        nvg("/productdetails", {
                                            state: {
                                                id: item.product,
                                                pname: item.product__title,
                                            },
                                        });
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    <img
                                        src={`${process.env.REACT_APP_API_URL}media/${item?.image?.[0]?.original}`}
                                        width="80px"
                                        height="80px"
                                        alt="cart"
                                        className=" "
                                    />
                                </div>
                            </td>
                            <td
                                className="pnwidth"
                                style={{ position: "relative", top: "0px" }}
                            >
                                <div
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "start",
                                        top: "0px",
                                    }}
                                >
                                    <h6>
                                        <p
                                            style={{
                                                color: "black",
                                                fontSize: "13px",
                                                // lineHeight: "22px",
                                                lineHeight:
                                                    item.stock == 0 ? "40px" : "63px",
                                                textAlign: "center",
                                                display: "-webkit-box",
                                                WebkitLineClamp: "1",
                                                WebkitBoxOrient: "vertical",
                                                cursor: "pointer",
                                                overflow: "hidden",
                                                position: "relative",
                                                top: "8px",
                                            }}
                                            onClick={() => {
                                                nvg("/productdetails", {
                                                    state: {
                                                        id: item.product,
                                                        pname: item.product__title,
                                                    },
                                                });
                                            }}
                                        >
                                            {item.product__title}
                                        </p>

                                        <p
                                            style={{
                                                color: "red",
                                                fontSize: "14px",
                                                textAlign: "center",
                                                position: "relative",
                                                top: "0px",
                                            }}
                                        >
                                            {" "}
                                            {(fullData.order_status !== "Delivery" && fullData.order_status !== "Cancelled") && item.awb && (
                                                <div style={{ color: 'black', fontSize: "14px", lineHeight: item.product__title.length > 23 ? "24px" : "33px", textAlign: 'start', position: 'relative', top: '-19px', left: '8px' }}>
                                                    <span onClick={() => fetchTrackingData(item.awb)}>
                                                        Track Awb : <span style={{ position: 'relative', top: '-5px', color: 'blue', cursor: 'pointer' }}>{item.awb}</span>
                                                    </span>
                                                </div>
                                            )}



                                        </p>
                                    </h6>
                                </div>
                            </td>

                            <td
                                style={{ position: "relative", padding: "0px" }}
                            >
                                <h6
                                    className="td-color"
                                    style={{
                                        fontWeight: 400,
                                        lineHeight: "63px",
                                        fontSize: "13px",
                                        textAlign: "center",
                                        textAlign: "center",
                                        position: "relative",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "start",
                                        top: "8px",
                                    }}
                                >
                                    {Accountprice(item.price_excl_tax)}
                                </h6>
                            </td>
                            <td className="td-color px-3" style={{ fontWeight: 400, lineHeight: "33px", fontSize: "14px", padding: '16px 0px' }}> <span><div style={{ display: 'flex', justifyContent: 'center', position: 'relative', top: '6px' }}>{item?.quantity}</div></span> </td>
                            <td
                                style={{ position: "relative", padding: "0px" }}
                            >
                                <h6
                                    className="td-color px-lg-0 px-md-2"
                                    style={{
                                        fontWeight: 400,
                                        lineHeight: "63px",
                                        fontSize: "13px",
                                        textAlign: "center",
                                        textAlign: "center",
                                        position: "relative",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "start",
                                        top: "8px",
                                    }}
                                >

                                    {item?.quote_discount ? item?.quote_discount : 0}%


                                </h6>
                            </td>
                            <td
                                style={{ position: "relative", padding: "0px" }}
                            >
                                <h6
                                    className="td-color px-lg-0 px-md-2"
                                    style={{
                                        fontWeight: 400,
                                        lineHeight: "63px",
                                        fontSize: "13px",
                                        textAlign: "center",
                                        textAlign: "center",
                                        position: "relative",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "start",
                                        top: "8px",
                                    }}
                                >
                                    {Accountprice((
                                        parseInt(item.price_excl_tax) * parseInt(item.quantity)
                                    ).toFixed(0))}{" "}


                                </h6>
                            </td>

                            <td
                                style={{ position: "relative", padding: "0px" }}
                            >
                                <h6
                                    className="td-color px-lg-0 px-md-2"
                                    style={{
                                        fontWeight: 400,
                                        lineHeight: "63px",
                                        fontSize: "13px",
                                        textAlign: "center",
                                        textAlign: "center",
                                        position: "relative",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "start",
                                        top: "8px",
                                    }}
                                >



                                    {Accountprice(Number.isInteger((item.base_price *
                                        item.quantity
                                    )) ? (
                                        item.base_price *
                                        item.quantity
                                    ) : (
                                        item.base_price *
                                        item.quantity
                                    ).toFixed(2))}
                                </h6>
                            </td>
                            <td
                                style={{ position: "relative", padding: "0px" }}
                            >
                                <h6
                                    className="td-color px-lg-0 px-md-2"
                                    style={{
                                        fontWeight: 400,
                                        lineHeight: "63px",
                                        fontSize: "13px",
                                        textAlign: "center",
                                        textAlign: "center",
                                        position: "relative",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "start",
                                        top: "8px",
                                    }}
                                >

                                    {item.gst_rate}%

                                </h6>
                            </td>
                            <td
                                style={{ position: "relative", padding: "0px" }}
                            >
                                <h6
                                    className="td-color px-lg-0 px-md-2"
                                    style={{
                                        fontWeight: 400,
                                        lineHeight: "63px",
                                        fontSize: "13px",
                                        textAlign: "center",
                                        textAlign: "center",
                                        position: "relative",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "start",
                                        top: "8px",
                                    }}
                                >
                                    {Accountprice(Number.isInteger(item.gst_tax_amount * item.quantity) ? (item.gst_tax_amount * item.quantity) : (item.gst_tax_amount * item.quantity).toFixed(2))}

                                </h6>
                            </td>

                        </tr>
                        <tr style={{ display: (ApiData.length - 1) == index ? "" : "none" }}>
                            <td colSpan={3} style={{ textAlign: 'center', fontSize: '12px', fontWeight: '600' }}>TOTAL</td>
                            <td style={{ textAlign: 'center', fontSize: '12px', fontWeight: '600' }} >{Count.qty}</td>
                            <td style={{ textAlign: 'center', fontSize: '12px', fontWeight: '600' }} ></td>
                            <td style={{ textAlign: 'center', fontSize: '12px', fontWeight: '600' }} >
                                {Accountprice(Count.mrp.toFixed(0))}</td>
                            <td style={{ textAlign: 'center', fontSize: '12px', fontWeight: '600' }} >
                                {Accountprice(Count.taxable.toFixed(0))}</td>
                            <td style={{ textAlign: 'center', fontSize: '12px', fontWeight: '600' }} ></td>
                            <td style={{ textAlign: 'center', fontSize: '12px', fontWeight: '600' }} >
                                {Accountprice(Count.gst.toFixed(0))}</td>
                        </tr>
                    </>
                    ))
                ) : (
                    <tr>
                        <td colSpan="9">
                            <h6
                                className="td-color"
                                style={{
                                    fontWeight: 400,
                                    lineHeight: "34px",
                                    fontSize: "14px",
                                    color: "#0cb744",
                                    textAlign: "center",
                                }}
                            >
                                No Item Found
                            </h6>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >

                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>

        {showtrack && (
                <div
                  style={{
                    position: 'fixed',
                    top: 25,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                  }}
                >
        
        
                  <div style={{ maxWidth: '32rem', minWidth: '32rem', margin: '0 auto', backgroundColor: 'white', padding: '1.5rem', border: '1px solid #e5e7eb', borderRadius: '0.5rem', minHeight: '10rem', maxHeight: '30rem', overflowY: 'auto' }}>
                    <div style={{
                      display: 'flex', justifyContent: 'space-between',
                    }}>
                      <span></span>
                      <span
                        onClick={() => setshowtrack(false)}
                        style={{
                          fontSize: '1.5rem',
                          color: 'red',
                          cursor: 'pointer'
        
                        }}
                      >
                        <IoIosCloseCircleOutline />
                      </span>
        
                    </div>
        
                    <div style={{ paddingBottom: '1rem', borderBottom: '1px solid #e5e7eb', marginBottom: '1rem' }}>
                      <h2 style={{ fontSize: '1.125rem', fontWeight: '600' }}>Delivery by OneUpShop</h2>
                      <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>Tracking ID:</p> <span> {awbNumber}</span>
                       <p style={{ fontSize: '0.875rem', color: '#6b7280',display:'inline' }}>Estimated Delivery Date:</p>  {trackingData.tracking_data.etd ? <span> {trackingData.tracking_data.etd.split(' ')[0]}</span> : 'Will be Updated After Pickup'}  
                      <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>This is your OneUpShop tracking number.</p>
                    </div>
        
                    {trackingData && trackingData.tracking_data.shipment_track_activities ? (
                      trackingData.tracking_data.shipment_track_activities.map((activity, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                            <p style={{ width: '5rem', fontSize: '0.75rem', color: '#6b7280' }}>
                              {activity.date ? new Date(activity.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '00:00'}
                            </p>
                          </div>
        
                          <div>
                            {activity.activity && (
                              <>
                                <p style={{ fontSize: '0.875rem', color: '#374151' }}>{activity.activity}</p>
                                <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>{activity.location || 'Warehouse'}</p>
                              </>
                            )}
                            {!activity.activity && (
                              <>
                                <p style={{ fontSize: '0.875rem', color: '#374151' }}>Unknown Activity</p>
                                <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>{activity.location || 'Warehouse'}</p>
                              </>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div>
                        <p>In Progress</p>
                      </div>
                    )}
        
        
        
        
        
        
                  </div>
                </div>
              )}
        </>
    )
}

export default Table